import { Diamond } from "lucide-react";

export default function Marquee({ items }) {
    const row = [...items, ...items];
    return (
        <div
            data-testid="ranks-marquee"
            className="overflow-hidden border-y border-white/10 bg-[#0D0F16]/60 py-3.5 backdrop-blur-sm"
        >
            <div className="marquee-track flex w-max items-center gap-8">
                {row.map((item, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-8 whitespace-nowrap font-code text-xs font-medium uppercase tracking-[0.25em] text-gray-500"
                    >
                        {item}
                        <Diamond className="h-2.5 w-2.5 text-violet-500" fill="currentColor" />
                    </span>
                ))}
            </div>
        </div>
    );
}
